import { Injectable } from '@angular/core';
import posthog from 'posthog-js';
import { getActiveFeatureFlagVariant } from '../../utils/posthog/posthog.utils';

export enum ApplianceTestVariants {
  Control = 'control',
  Conversational = 'conversational',
}
@Injectable({
  providedIn: 'root',
})
export class AbTestingService {
  private readonly APPLIANCE_DETAILS_TEST_KEY =
    'appliance-details-conversational';

  async getApplianceDetailsVariant(): Promise<ApplianceTestVariants> {
    /* TODO: Remove this in production */
    /* Search for sessionStorage for a flag, if it exists, it overrides all else */
    /* istanbul ignore next */
    const localFlag = sessionStorage.getItem('ab-test-conversational');
    /* istanbul ignore next */
    if (localFlag === 'true') {
      /* istanbul ignore next */
      return ApplianceTestVariants.Conversational;
    }

    /* TODO: Remove this in production */
    /* If there is a 'conversational=true' query param, then store the flag in sessionStorage */
    /* istanbul ignore next */
    const queryParams = new URLSearchParams(document.location.search);
    /* istanbul ignore next */
    if (queryParams.get(ApplianceTestVariants.Conversational) === 'true') {
      /* istanbul ignore next */
      sessionStorage.setItem('ab-test-conversational', 'true');
      /* istanbul ignore next */
      return ApplianceTestVariants.Conversational;
    }

    /* Wait for the flags to load */
    await new Promise((resolve) =>
      posthog.onFeatureFlags((flags) => resolve(flags))
    );

    /* Get the feature flag*/
    const featureFlag = <ApplianceTestVariants>(
      getActiveFeatureFlagVariant(
        this.APPLIANCE_DETAILS_TEST_KEY,
        ApplianceTestVariants
      )
    );

    return featureFlag || ApplianceTestVariants.Control;
  }
}
